module.exports = __webpack_public_path__ + "static/media/icon2.79c75fb7.svg";